import React, { Component } from "react";
import { Card } from '@deere/ux.uxframe-react';
import Button from "../../reusable/components/Button.jsx";

class CommoditiesSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prosNumber: this.props.companyInfoObjCOM.prosNumber
        };
        this.handleCommoditiesEditBtn = this.handleCommoditiesEditBtn.bind(this);
    }
    handleCommoditiesEditBtn(e) {
        document.location.href = "/commodity-info/" + this.state.prosNumber
    }
    render() {
        return (
            <div>
                <div class="row">
                    {Object.values(this.props.commoditiesInfoData).map((commodities, i) =>
                        <div class="col-sm-8">
                            <div><label class="uxf-label">{commodities.title}</label></div>
                            <ul class="uxf-ul">{commodities.itemList.filter((subCommoditiObj) => subCommoditiObj.selected === true).map(subCommodities =>
                                <li>{subCommodities.description}</li>
                            )}
                            </ul>
                        </div>
                    )}
                </div>
                {this.props.companyInfoObjCOM.userRole !== undefined && this.props.companyInfoObjCOM.userRole !== null && this.props.companyInfoObjCOM.userRole !== "VIEW_ONLY"
                    && this.props.companyInfoObjCOM.status !== "A" && this.props.companyInfoObjCOM.status !== "D" && this.props.companyInfoObjCOM.status !== "N" ?
                    <div class="row">
                        <div class="col-sm-24" style={{ textAlign: 'right' }}>
                            <Button action={this.handleCommoditiesEditBtn} type="secondary" title="Edit" />{" "}
                        </div>
                    </div>
                    : ''}
            </div>
        )
    }
}
export default CommoditiesSummary;